import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { PlanMedioPagoModel } from 'src/app/core/models/response/plan-medio-pago.model';
import { TarifarioService } from 'src/app/core/services/tarifario.service';

@Injectable()
export class PlanesTarifasResolver implements Resolve<PlanMedioPagoModel[]> {
  constructor(private tarifarioService: TarifarioService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any[]> {
    return this.tarifarioService.getPlanesTipoMedioPago();
  }
}
